import ErrorView from './errors/ErrorView'
import { Page, ls, useWindowContext } from '@iqueue/ui-kit'
import { useMemo, useEffect, useState, useCallback } from 'react'
import { t } from '../hooks/useTranslate'

export default function PaginatedPage({
  preload,
  presenter,
  storeKey,
  component: Cmp,
  autoReload = true,
  paddings = false,
  scrollbars = false,
  ...props
}) {
  const { setTitle, togglePaddings, toggleScrollbars } = useWindowContext()
  // TODO reload on tab visibility changed

  const [pagination, setPagination] = useState({
    limit: 25,
    page: 1,
  })

  const [args, setArgs] = useState(null)

  const handlePageChange = useCallback((page, pageSize) => {
    setPagination({
      limit: pageSize,
      offset: (page - 1) * pageSize,
    })
  }, [])

  const handleFilterChange = useCallback(() => {

  }, [])

  const component = useMemo(() => {
    return (props) => <Cmp
      { ...props }
      presenter={ presenter }
    />
  }, [presenter, Cmp])

  useEffect(() => {
    setTitle(t('page.title'))
  }, [t, setTitle])

  useEffect(() => {
    togglePaddings(paddings)
  }, [paddings, togglePaddings])

  useEffect(() => {
    toggleScrollbars(scrollbars)
  }, [scrollbars, toggleScrollbars])

  useEffect(() => {
    const key = storeKey || presenter.urn
    setArgs(ls(`table-${ key }-args`) || {
      limit: 25,
    })
  }, [])

  if (args === null) return false

  return <Page
    errorView={ ErrorView }
    component={ component }
    preload={ presenter.paginated }
    preloadArgs={ [args] }
    { ...props }
  />
}
